import { LoadingScreen } from '@avanta/shared/components/LoadingScreen';
import { Card } from '@avanta/shared/components/ui/Card';
import { useFetchNextAppointments } from 'hooks/useFetchNextAppointments';
import { useIsPatientOrEmployee } from 'stores/user';
import { type Appointment } from 'types/appointments';
import { isUpcomingAppointment } from 'utils/appointments';
import { CardActions } from './components/CardActions';
import { CardHeader } from './components/CardHeader';
import { PsychologistInfo } from './components/PsychologistInfo';
import { SessionDetailsSection } from './components/SessionDetailsSection';

export const AppointmentCard = ({
  patientId,
  appointment: appointmentFromProps,
}: {
  patientId: string;
  appointment?: Appointment;
}): React.ReactElement | null => {
  const appointmentId = appointmentFromProps?.id;
  const { data: nextAppointments, isPending } = useFetchNextAppointments(
    patientId,
    appointmentFromProps?.psychologistId
  );

  const isInitialLoading = isPending && !nextAppointments;
  const appointment = appointmentId
    ? nextAppointments?.find(appointment => appointment.id === appointmentId)
    : nextAppointments?.find(isUpcomingAppointment);
  const isPatientOrEmployee = useIsPatientOrEmployee();

  if (!appointment || appointment.canceled) return null;

  if (isInitialLoading) {
    return <LoadingScreen />;
  }

  return (
    <Card>
      <div className="flex flex-col gap-8">
        <CardHeader appointment={appointment} />
        <SessionDetailsSection appointment={appointment} />
        {isPatientOrEmployee && <PsychologistInfo appointment={appointment} />}
        <CardActions appointment={appointment} />
      </div>
    </Card>
  );
};
